var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPieApprove24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_pie_approve24x24",
    d: "M16.293,2.554a.759.759,0,0,0-1,0L6.984,10.094,2.7,6.183a.756.756,0,0,0-1,0l-1.5,1.36a.6.6,0,0,0,0,.907l6.275,5.731a.764.764,0,0,0,1,0L17.792,4.824a.6.6,0,0,0,0-.91Z",
    transform: "translate(0 -2.367)",
    fill: "#fae79f"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPieApprove24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_pie_approve24x24.1168d6a9f568b003f64527fd24f2f7d1.svg";